import React from 'react';

import { Typography } from '@mui/material';

function Title({ title }) {
  return (
    <Typography variant="h6" component="h2" noWrap color="text.primary">
      {title}
    </Typography>
  );
}
export default Title;
